module.exports = " <div class=redactor-fieldtype-wrapper> <textarea v-el:redactor :name=name v-model=data></textarea> <selector v-if=showAssetSelector :container=container :folder=folder :selected=selectedAssets :restrict-navigation=restrictAssetNavigation @selected=assetsSelected @closed=closeAssetSelector></selector> </div> ";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-html-loader!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/statamic/resources/js/components/fieldtypes/redactor/RedactorFieldtype.vue
// module id = 714
// module chunks = 0